<div class="flex items-center justify-between mb-2">
  <button
    type="button"
    class="flex items-center"
    [disabled]="!previousEnabled()"
    (click)="previousClicked()"
    [attr.aria-label]="prevButtonLabel"
  >
    <svg-icon key="chevron-left-24" [ngClass]="previousEnabled() ? 'text-action-primary' : 'text-foreground-primary-60'"></svg-icon>
  </button>

  <div
    class="flex justify-center items-center text-foreground-primary-100 font-semibold text-large"
    [class.cursor-pointer]="currentPeriodEnabled"
    (click)="currentPeriodClicked()"
  >
    {{periodButtonText | uppercase}}
  </div>

  <button type="button" class="flex items-center" [disabled]="!nextEnabled()" (click)="nextClicked()" [attr.aria-label]="nextButtonLabel">
    <svg-icon key="chevron-right-24" [ngClass]="nextEnabled() ? 'text-action-primary' : 'text-foreground-primary-60'"></svg-icon>
  </button>
</div>
